var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ROOT_FOLDER } from '../../folders/root-folder';
export var DRIVE_PAGE_NAMES = {
    FOLDER: 'folder',
    RECENT: 'recent',
    TRASH: 'trash',
    SHARES: 'shares',
    STARRED: 'starred',
    ROOT: 'root',
    SEARCH: 'search',
};
var DrivePage = /** @class */ (function () {
    function DrivePage(params) {
        var _this = this;
        this.name = null;
        this.viewName = null;
        this.folder = null;
        this.folderHash = null;
        this.hasActions = false;
        this.sortColumn = 'updated_at';
        this.sortDirection = 'desc';
        this.queryParams = {};
        Object.keys(params).forEach(function (key) {
            _this[key] = params[key];
        });
    }
    return DrivePage;
}());
export { DrivePage };
var DriveFolderPage = /** @class */ (function (_super) {
    __extends(DriveFolderPage, _super);
    function DriveFolderPage(folder) {
        return _super.call(this, {
            folder: folder,
            name: DRIVE_PAGE_NAMES.FOLDER,
            hasActions: true,
            viewName: folder === ROOT_FOLDER ? 'Drive' : folder.name,
            folderHash: folder ? folder['hash'] : null,
        }) || this;
    }
    return DriveFolderPage;
}(DrivePage));
export { DriveFolderPage };
export var RECENT_PAGE = new DrivePage({
    name: DRIVE_PAGE_NAMES.RECENT,
    viewName: 'Recent',
    disableSort: true,
    sortColumn: 'created_at',
    sortDirection: 'desc',
    queryParams: {
        recentOnly: true,
    }
});
export var SEARCH_PAGE = new DrivePage({
    name: DRIVE_PAGE_NAMES.SEARCH,
    viewName: 'Search results',
});
export var SHARES_PAGE = new DrivePage({
    name: DRIVE_PAGE_NAMES.SHARES,
    viewName: 'Shared with me',
    queryParams: {
        sharedOnly: true,
    }
});
export var TRASH_PAGE = new DrivePage({
    name: DRIVE_PAGE_NAMES.TRASH,
    viewName: 'Trash',
    hasActions: true,
    queryParams: {
        deletedOnly: true,
    }
});
export var STARRED_PAGE = new DrivePage({
    name: DRIVE_PAGE_NAMES.STARRED,
    viewName: 'Starred',
    queryParams: {
        starredOnly: true,
    }
});
export var ROOT_FOLDER_PAGE = new DrivePage({
    name: DRIVE_PAGE_NAMES.ROOT,
    viewName: 'Drive',
    folder: ROOT_FOLDER,
    hasActions: true,
});
export var FOLDER_PAGE = new DrivePage({
    name: DRIVE_PAGE_NAMES.FOLDER,
    viewName: null,
    hasActions: true
});
